
export default {
    en: {
        // constantes
        'Une démo':'A demo',
        'Statut échéancier':'Schedule Status',
        'En attente de paiement':'Pending Payment',
        'Une information':'An information',
        'Expiré':'Expired',
        'Impayé':'Unpaid',
        'Non lue' :'Non lue',
        'Données profil':'Profile data',
        'En attente de validation' :'Awaiting approval',
        'Annulée': 'Cancelled',
        'Interruption en cours': 'Interruption in progress',
        'Tout les status': 'All statuses',
        'En attente validation-Client':'Pending client validation',
        'Rejeté':'Rejected',
        'En attente validation-Expert':'Pending expert validation',
        'Validé ':'Validated',
        'Cra Nul':'Null CRA',
        'Reçue' :'Reçue',
        'Intéressante' :'Intéressante',
        'A interviewer' :'A interviewer',
        'Retenue' :'Retenue',
        'Non retenue' :'Non retenue',
        'BDC signé' :'BDC signé',
        'Mission confirmée' : 'Confirmed mission',
        'CVThèque-AO':'CVThèque-AO',
        'Dispo. à vérifier':'Available to check',
        'Mission créée':'Mission created',
        'Ajouter/déduire':'Add/Deduct',
        'Montant/Client':'Amount/Customer',
        'Montant/Expert':'Amount/Expert',
        'Total des astreintes/Client':'Total on-call time/Customer',
        'Total des astreintes/Expert':'Total on-call time/Expert',
        'Total des HNO/Client':'Total NWH/Customer',
        'HNO/Expert':'NWH/Expert',
        'Type du note de frais':'Type of expense claim',
        'Montant total HT /Expert':'Total amount excl. tax /Expert',
        'Montant total/Client':'Total amount/Customer',
        'To do':'To do',
        'In progress':'In progress',
        'Done':'Done',
        '1 mois':'1 month',
        '3 mois':'3 months',
        '6 mois':'6 months',
        '12 mois':'12 months',
        'Données PC':'CS data',
        'Contrat':'Contract',
        '> 12 mois':'> 12 months',
        '30 jours':'30 days',
        '45 jours':'45 days',
        '60 jours':'60 days',
        'Invitation en attente':'Pending invitation',
        'Appel d\'offres':'Call for tenders',
        'AO avec candidature':'AO with application',
        'Toutes les candidatures':'All applications',
        'CV':'CV',
        'CIN':'ID',
        'Attestation honneur':'Sworn statement',
        'CDI':'Permanent contract',
        'CDD':'Fixed-term contract',
        'CTT':'Temporary contract',
        'Freelance':'Freelance',
        '1 an':'1 year',
        '2 ans':'2 years',
        '3 ans':'3 years',
        '4 ans':'4 years',
        '5 ans':'5 years',
        '10 ans':'10 years',
        'ans':'years',
        'En attente d\'acceptation':'Pending acceptance',
        'Replanifié':'Rescheduled',
        'Accepté':'Accepted',
        'rejeté':'Rejected',
        'annulé':'Cancelled',
        'planifie':'Scheduled',
        'replanifie':'Rescheduled',
        'accepte':'Accepted',
        'rejete':'Rejected',
        'annule':'Cancelled',
        'Audio-conférence':'Audio conference',
        'Visio-conférence':'Video conference',
        'Sur site':'On-site',
        '1 à 2ans':'1 to 2 years',
        'Confirmé':'Confirmed',
        'Senior':'Senior',
        'Notions':'Basic',
        'Coefficient':'Coefficient',
        'Ecole élémentaire':'Elementary school',
        'Diplôme national du brevet':'National diploma of the brevet',
        'CAP/BEP':'CAP/BEP',
        'Baccalauréat':'Baccalaureate',
        'BTS/DUT':'BTS/DUT',
        'Licence /Licence professionnelle':'Bachelor\'s degree/Professional Bachelor\'s degree',
        'Master/Titre d\'ingénieur':'Master\'s degree/Engineer\'s degree',
        'Doctorat':'Doctorate',
        'Janvier':'January',
        'Février':'February',
        'Mars':'March',
        'Avril':'April',
        'Mai':'May',
        'Juin':'June',
        'Juillet':'July',
        'Août':'August',
        'Septembre':'September',
        'Octobre':'October',
        'Novembre':'November',
        'Décembre':'December',
        'Chargé de Recrutement':'Recruitment officer',
        'Non Validé':'Not validated',
        'Aucune':'None',
        'Généré':'Generated',
        'Généré-G':'Generated-G',
        'Proforma':'Proforma',
        'à valider':'To validate',
        'En attente':'Pending',
        'Aérospatiale':'Aerospace',
        'Alimentation santé':'Health food',
        'Ameublement':'Furniture',
        'Appareils médicaux et instruments scientifiques':'Medical devices and scientific instruments',
        'Assurances':'Insurance',
        'Autres':'Others',
        'Biens d\'équipement':'Equipment goods',
        'Bioalimentaire':'Biofood',
        'Biotechnologies':'Biotechnologies',
        'Centre de contacts clients':'Customer contact centers',
        'Centre de données et services connexes':'Data centers and related services',
        'Chimie':'Chemistry',
        'Commerce de détail et de gros':'Retail and wholesale',
        'Construction et ingénierie':'Construction and engineering',
        'Cybersécurité':'Cybersecurity',
        'Effets visuels et animation':'Visual effects and animation',
        'Énergies renouvelables':'Renewable energies',
        'Finance':'Finance',
        'Instrumentation test et mesures':'Test and measurement instruments',
        'Jeux vidéo':'Video games',
        'Logiciel':'Software',
        'Logistique et transport':'Logistics and transport',
        'Matériaux avancés':'Advanced materials',
        'Métallurgie':'Metallurgy',
        'Minéraux':'Minerals',
        'Optique photonique':'Optics photonics',
        'Pétrochimie':'Petrochemicals',
        'Pharmaceutiques':'Pharmaceuticals',
        'Plasturgie':'Plastics',
        'Production cinématographique':'Film production',
        'Produits forestiers':'Forest products',
        'Récréotouristique':'Recreation and tourism',
        'Santé numérique':'Digital health',
        'Science et analyse de données':'Science and data analysis',
        'Sécurité et défense':'Security and defense',
        'Services administratifs':'Administrative services',
        'Services d\'affaires':'Business services',
        'Services d\'enseignement':'Education services',
        'Services d\'hébergements et de restauration':'Accommodation and catering services',
        'Services de santé':'Health services',
        'Services environnementaux':'Environmental services',
        'Services informatiques':'IT services',
        'Services techniques':'Technical services',
        'Télécommunications':'Telecommunications',
        'Textile et vêtements':'Textiles and clothing',
        'Transport maritime':'Maritime transport',
        'Transport terrestre (sauf véhicules électrique)':'Land transport (except electric vehicles)',
        'Véhicule électrique':'Electric vehicle',
        'Tableau de bord': 'Dashboard',
        'Documents administratifs': 'Administrative Documents',
        'Paramètres de compte': 'Account Settings',
        'Rechercher un AO': 'Search for AO',
        'Mes candidatures': 'My Applications',
        'Mes favoris': 'My Favorites',
        'Mes RDV': 'My Appointments',
        'Missions et BDC': 'Missions and BDC',
        'Orderes de mission': 'Task Orders',
    },
    fr: {
        //constantes
        'Une démo':'Une démo',
        'Statut échéancier':'Statut échéancier',
        'En attente de paiement':'En attente de paiement',
        'Une information':'Une information',
        'Expiré':'Expiré',
        'Ajouter/déduire':'Ajouter/déduire',
        'Montant/Client':'Montant/Client',
        'Montant/Expert':'Montant/Expert',
        'Total des astreintes/Client':'Total des astreintes/Client',
        'Total des astreintes/Expert':'Total des astreintes/Expert',
        'Total des HNO/Client':'Total des HNO/Client',
        'HNO/Expert':'HNO/Expert',
        'Type du note de frais':'Type du note de frais',
        'Montant total HT /Expert':'Montant total HT /Expert',
        'Montant total/Client':'Montant total/Client',
        'CVThèque-AO':'CVThèque-AO',
        'Mission confirmée':'Mission confirmée',
        'Impayé':'Impayé',
        'Mission créée':'Mission créée',
        'To do':'To do',
        'In progress':'In progress',
        'Done':'Done',
        '1 mois':'1 mois',
        '3 mois':'3 mois',
        '6 mois':'6 mois',
        '12 mois':'12 mois',
        'Données PC':'Données PC',
        'Contrat':'Contrat',
        '> 12 mois':'> 12 mois',
        '30 jours':'30 jours',
        '45 jours':'45 jours',
        '60 jours':'60 jours',
        // 'Actif':'Actif',
        'Passif':'Passif',
        'Invitation en attente':'Invitation en attente',
        'Appel d\'offres':'Appel d\'offres',
        'AO avec candidature':'AO avec candidature',
        'Toutes les candidatures':'Toutes les candidatures',
        'CV':'CV',
        'CIN':'CIN',
        'Attestation honneur':'Attestation honneur',
        'CDI':'CDI',
        'CDD':'CDD',
        'CTT':'CTT',
        'Freelance':'Freelance',
        '1 an':'1 an',
        '2 ans':'2 ans',
        '3 ans':'3 ans',
        '4 ans':'4 ans',
        '5 ans':'5 ans',
        '10 ans':'10 ans',
        'En attente d\'acceptation':'En attente d\'acceptation',
        'Rplanifié':'Replanifié',
        'Accepté':'Accepté',
        'rejeté':'rejeté',
        'annulé':'annulé',
        'planifie':'planifie',
        'replanifie':'replanifie',
        'accepte':'accepte',
        'rejete':'rejete',
        'annule':'annule',
        'Audio-conférence':'Audio-conférence',
        'Visio-conférence':'Visio-conférence',
        '1 à 2ans':'1 à 2ans',
        'Confirmé':'Confirmé',
        'Senior':'Senior',
        'Notions':'Notions',
        'Coefficient':'Coefficient',
        'Ecole élémentaire':'Ecole élémentaire',
        'Diplôme national du brevet':'Diplôme national du brevet',
        'CAP/BEP':'CAP/BEP',
        'Baccalauréat':'Baccalauréat',
        'BTS/DUT':'BTS/DUT',
        'Licence /Licence professionnelle':'Licence /Licence professionnelle',
        'Master/Titre d\'ingénieur':'Master/Titre d\'ingénieur',
        'Doctorat':'Doctorat',
        'Janvier':'Janvier',
        'Février':'Février',
        'Mars':'Mars',
        'Avril':'Avril',
        'Mai':'Mai',
        'Juin':'Juin',
        'Juillet':'Juillet',
        'Août':'Août',
        'Septembre':'Septembre',
        'Octobre':'Octobre',
        'Novembre':'Novembre',
        'Décembre':'Décembre',
        'Chargé de Recrutement':'Chargé de Recrutement',
        'Non Validé':'Non Validé',
        'Aucune':'Aucune',
        'Généré':'Généré',
        'Généré-G':'Généré-G',
        'Proforma':'Proforma',
        'à valider':'à valider',
        'En attente':'En attente',
        'Aérospatiale':'Aérospatiale',
        'Alimentation santé':'Alimentation santé',
        'Ameublement':'Ameublement',
        'Appareils médicaux et instruments scientifiques':'Appareils médicaux et instruments scientifiques',
        'Assurances':'Assurances',
        'Autres':'Autres',
        'Biens d\'équipement':'Biens d\'équipement',
        'Bioalimentaire':'Bioalimentaire',
        'Biotechnologies':'Biotechnologies',
        'Centre de contacts clients':'Centre de contacts clients',
        'Centre de données et services connexes':'Centre de données et services connexes',
        'Chimie':'Chimie',
        'Commerce de détail et de gros':'Commerce de détail et de gros',
        'Construction et ingénierie':'Construction et ingénierie',
        'Cybersécurité':'Cybersécurité',
        'Effets visuels et animation':'Effets visuels et animation',
        'Énergies renouvelables':'Énergies renouvelables',
        'Finance':'Finance',
        'Instrumentation test et mesures':'Instrumentation test et mesures',
        'Jeux vidéo':'Jeux vidéo',
        'Logiciel':'Logiciel',
        'Logistique et transport':'Logistique et transport',
        'Matériaux avancés':'Matériaux avancés',
        'Métallurgie':'Métallurgie',
        'Minéraux':'Minéraux',
        'Optique photonique':'Optique photonique',
        'Pétrochimie':'Pétrochimie',
        'Pharmaceutiques':'Pharmaceutiques',
        'Plasturgie':'Plasturgie',
        'Production cinématographique':'Production cinématographique',
        'Produits forestiers':'Produits forestiers',
        'Récréotouristique':'Récréotouristique',
        'Santé numérique':'Santé numérique',
        'Science et analyse de données':'Science et analyse de données',
        'Sécurité et défense':'Sécurité et défense',
        'Services administratifs':'Services administratifs',
        'Services d\'affaires':'Services d\'affaires',
        'Services d\'enseignement':'Services d\'enseignement',
        'Services d\'hébergements et de restauration':'Services d\'hébergements et de restauration',
        'Services de santé':'Services de santé',
        'Services environnementaux':'Services environnementaux',
        'Services informatiques':'Services informatiques',
        'Services techniques':'Services techniques',
        'Télécommunications':'Télécommunications',
        'Textile et vêtements':'Textile et vêtements',
        'Transport maritime':'Transport maritime',
        'Transport terrestre (sauf véhicules électrique)':'Transport terrestre (sauf véhicules électrique)',
        'Véhicule électrique':'Véhicule électrique',
        'Données profil':'Données profil',
        'Tableau de bord':'Tableau de bord',
        'Documents administratifs':'Documents administratifs',
        'Paramètres de compte':'Paramètres de compte',
        'Rechercher un AO':'Rechercher un AO',
        'Mes candidatures':'Mes candidatures',
        'Mes favoris':'Mes favoris',
        'Mes RDV':'Mes RDV',
        'Mssions et BDC':'Missions et BDC',
        'Orderes de mission':'Orderes de mission',

    },
};